module.exports = __webpack_public_path__ + "static/media/addImg.ba2a3a8b.png";